import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9f95ee06&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=9f95ee06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f95ee06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f95ee06')) {
      api.createRecord('9f95ee06', component.options)
    } else {
      api.reload('9f95ee06', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9f95ee06&scoped=true&", function () {
      api.rerender('9f95ee06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/lab/country-proj/index.vue"
export default component.exports